/*
 * © 2026 Ecsper Ltd. All rights reserved.
 * SPDX-License-Identifier: LicenseRef-Ecsper-Proprietary
 * Unauthorised use, copying, or distribution is strictly prohibited.
 */

import type { AnalysisResponse } from '@ecsper/api-client';
import type { ReactElement } from 'react';

export function RealAnalysisView({
  analysis,
}: {
  readonly analysis: AnalysisResponse | null;
}): ReactElement | null {
  if (analysis === null) {
    return null;
  }

  return (
    <div className="ecs-ai-panel__analysis" role="region" aria-live="polite">
      {analysis.message ?? analysis.status}
    </div>
  );
}
